import { render, staticRenderFns } from "./AddAlias.vue?vue&type=template&id=875ed8ea&scoped=true&"
import script from "./AddAlias.vue?vue&type=script&lang=js&"
export * from "./AddAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875ed8ea",
  null
  
)

export default component.exports